import { Component, OnInit, Inject } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormBuilder } from '@angular/forms';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LoaderService } from '../../shared/loader/loader.service';
import { AttachAIAutomationTemplateComponent } from '../attachAIAutomationTemplate/attachAIAutomationTemplate.component';
import { ModuleName } from '../Enum/common.enum';

@Component({
  selector: 'app-folderForReferral',
  templateUrl: './folderForReferral.component.html',
  styleUrls: ['./folderForReferral.component.scss']
})

export class FolderForReferralComponent implements OnInit {

  organizationId: any;
  databaseId: any;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;
  ReferralTemplateFolders: any = [] = [];
  folderID: number = 0;
  ShowNoRecordFound: boolean = false;
  showSaveButton: boolean = true;

  FileManagerFolderList: any = [] = [];
  rememberNodeArray: any = [] = [];
  activeNode: string = "";
  FileManagerOfficeFolderList: any = [] = [];
  commingFrom:string="";
  coreModuleName:string="";

  private _transformer = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared,
      isFile: node.isFile,
      aiAutomationTemplateID: node.aiAutomationTemplateID,
      aiAutomationTemplateName: node.aiAutomationTemplateName,
      isReferralFolder: node.isReferralFolder,
      isCoreFolder: node.isCoreFolder,
    };
  }

  private _transformerFileManager = (node: ReportNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      subFolderID: node.subFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared,
      isFile: node.isFile,
      aiAutomationTemplateID: node.aiAutomationTemplateID,
      aiAutomationTemplateName: node.aiAutomationTemplateName,
      isReferralFolder: node.isReferralFolder,
      isCoreFolder: node.isCoreFolder,
    };
  }

  private _transformerOffice = (node: ReportNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      subFolderID: node.subFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared,
      isFile: node.isFile,
      aiAutomationTemplateID: node.aiAutomationTemplateID,
      aiAutomationTemplateName: node.aiAutomationTemplateName,
      isReferralFolder: node.isReferralFolder,
      isCoreFolder: node.isCoreFolder,
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);

  treeControlOffice = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerOffice = new MatTreeFlattener(this._transformerOffice, node => node.level, node => node.expandable, node => node.children);
  dataSourceOffice = new MatTreeFlatDataSource(this.treeControlOffice, this.treeFlattenerOffice);



  hasChild = (_: number, node: ExampleFlatNodeFileManager) => node.expandable;


  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<FolderForReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService,
    private statusConst: StatusConstant, private toastr: ToastrService,
    private loaderService: LoaderService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

  }

  ngOnInit(): void {
     var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules") ?? '[]');
     var Module:any=[];
     Module = menuModulesList.filter((x: any) => x.mainModuleName == ModuleName.Core);
     if (Module.length > 0) {
       this.coreModuleName = Module[0].orgModuleName;       
      }
    this.commingFrom= this.data.from;
    this.folderID = this.data.fileManagerItemID;
    //this.getFileManagerFolderList();
    this.getOfficeFoldersList();
  }

  getFileManagerFolderList() {
    let reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.settingsService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderList = this.responseHolder.data.data;
          if (this.FileManagerFolderList != null) {
            this.FileManagerFolderList = this.FileManagerFolderList.filter(function (el:any) {
              return el != null;
            });
          }

          if (this.FileManagerFolderList != null) {
            this.dataSource.data = this.FileManagerFolderList;                   
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getOfficeFoldersList() {
    var reqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.settingsService.getOfficeFolders(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerOfficeFolderList = this.responseHolder.data;
          if (this.FileManagerOfficeFolderList != null && this.FileManagerOfficeFolderList != undefined) {
            this.dataSourceOffice.data = this.FileManagerOfficeFolderList;
          }
        }
        else {
          this.FileManagerOfficeFolderList = [];
        }
      } else {
        this.FileManagerOfficeFolderList = [];
      }
    });
  }

  rememberNode(nodeId: any, e: any) {
    if (!this.rememberNodeArray.find((m: any) => m == nodeId))
      this.rememberNodeArray.push(nodeId);
    if (e.currentTarget.innerText == 'arrow_drop_down') {
      this.rememberNodeArray = this.rememberNodeArray.filter((m: any) => m != nodeId)
    }
  }

  // GetReferralTemplateFolders(): void {
  //   this.loaderService.show();
  //   this.settingsService.getReferralTemplateFolders(this.currentUser.UID,
  //     this.organizationId,
  //     this.myOfficeID,
  //     this.databaseId).subscribe({
  //       next: (response: any) => {
  //         if (response) {
  //           this.responseHolder = response;
  //           this.loaderService.hide();
  //           if (this.responseHolder.status === this.statusConst.statusSuccess) {
  //             this.ReferralTemplateFolders = response.data || [];
  //             if (this.ReferralTemplateFolders.length > 0) {
  //               this.ShowNoRecordFound = false;
  //             } else {
  //               this.ShowNoRecordFound = true;
  //             }
  //           } else {
  //             this.loaderService.hide();
  //           }
  //         }
  //         this.loaderService.hide();
  //       },
  //       error: (err) => {
  //         this.loaderService.hide();
  //       }
  //     });
  // }

  SelectFolder(folder: any) {
    this.folderID = folder.fileManagerItemID;//folder.folderID;
    this.showSaveButton = false;
  }

  SetDefaultFodlerForReferral() {
    var reqModel = {
      folderID: this.folderID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.showSaveButton = true;
    this.spinner = true;
    this.loaderService.show();
    this.settingsService.setDefaultFodlerForReferral(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        this.showSaveButton = false;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close("RecordAdded");
          this.toastr.success('File manager folder set successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.showSaveButton = false;
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.showSaveButton = false;
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  close() {
    this.showSaveButton = true;
    this.folderID = 0;
    this.dialog.closeAll();
  }

  openAITemplate(data: any) {
    var searchType:number=0;

    if(this.commingFrom=="Referral Management"){
       searchType=2;
    }
    if(this.commingFrom=="Core"){
      searchType=0;
    }
    const dialogRef = this.dialog.open(AttachAIAutomationTemplateComponent, {
      data: {
        From: this.commingFrom,
        selectedFolderName: data.name,
        fileManagerItemID: data.fileManagerItemID,
        searchType: searchType  //0-All , 1--WithoutReferral ,2--OnlyReferral
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.dialogRef.close("RecordAdded");        
      }
    });
  }

  selectedTabIndex = 0;

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;

    if (event.index === 0) {
      // Office Drive
     // this.getFileManagerFolderList();
       this.getOfficeFoldersList();
    } else {
      // My Drive
      //this.getOfficeFoldersList();
      this.getFileManagerFolderList();
    }
  }


}



interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  subFolderID: number;
  parentID: number;
  isShared: boolean;
  isFile: boolean;
  aiAutomationTemplateID: number;
  aiAutomationTemplateName: string;
  isReferralFolder: boolean;
   isCoreFolder: boolean
}

interface ReportNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  subFolderID: number;
  parentID: number;
  isShared: boolean;
  isFile: boolean;
  aiAutomationTemplateID: number;
  aiAutomationTemplateName: string;
  isReferralFolder: boolean;
   isCoreFolder: boolean
}

interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  subFolderID: number;
  parentID: number;
  isShared: boolean;
  isFile: boolean;
  aiAutomationTemplateID: number;
  aiAutomationTemplateName: string;
  isReferralFolder: boolean;
   isCoreFolder: boolean
}